// extracted by mini-css-extract-plugin
export default {"isHidden":"CursorFollower_isHidden__MyPiK"};